module.exports = __webpack_public_path__ + "static/media/btn-close.0380828c.svg";